import React, { PropsWithChildren } from "react";

import css from "./sticky_item.module.scss";

export const StickyItem = ({ children }: PropsWithChildren): JSX.Element => (
  <div className={css.root}>{children}</div>
);
